import React, { useState } from "react";
import { api } from "../../../../../../../utils/api";
import { useLocation } from "react-router-dom";

const HeroClassic = ({ config }) => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", cep: "" });
  const { state } = useLocation();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const enterprise_id = state?.enterprise_id;
    try {
      await api.post("/landingPage/lead", { ...form, enterprise_id });
      alert("Enviado!");
    } catch (err) {
      alert("Erro ao enviar!");
      console.error(err);
    }
  };

  return (
    <section
      id="cabecalho"
      className="d-flex align-items-center justify-content-center text-white"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.6)), url(${config.header?.imagemFundo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "100vh",
        padding: "4rem 2rem",
      }}
    >
      <div className="container">
        <div className="row align-items-center justify-content-between">
          {/* Coluna Esquerda */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h1
              className="display-3 fw-bold titlleTemplateClassic"
              style={{ fontFamily: "Axiforma, sans-serif" }}
            >
              {config.header?.nome || "LOGO"}
            </h1>
            <p
              className="fs-5"
              style={{
                maxWidth: "500px",
                fontFamily: "Axiforma, sans-serif",
                lineHeight: "1.6",
              }}
            >
              {config.header?.descricao ||
                "Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur..."}
            </p>
          </div>

          {/* Coluna Direita: Formulário */}
          <div className="col-lg-5">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: `#${config.primaryColor || "0d1b2a"}`, color: "white" }}
            >
              <h2
                className="mb-4 fs-3"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                FALE CONOSCO
              </h2>
              <form id="formulario" onSubmit={handleSubmit}>
                {config.formulario?.name && (
                  <div className="mb-3">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Nome"
                      value={form.name}
                      onChange={handleChange}
                      style={{ borderRadius: "6px" }}
                    />
                  </div>
                )}
                {config.formulario?.email && (
                  <div className="mb-3">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      placeholder="Email"
                      value={form.email}
                      onChange={handleChange}
                      style={{ borderRadius: "6px" }}
                    />
                  </div>
                )}
                {config.formulario?.phone && (
                  <div className="mb-3">
                    <input
                      type="tel"
                      name="phone"
                      className="form-control"
                      placeholder="Telefone"
                      value={form.phone}
                      onChange={handleChange}
                      style={{ borderRadius: "6px" }}
                    />
                  </div>
                )}
                {config.formulario?.cep && (
                  <div className="mb-4">
                    <input
                      type="text"
                      name="cep"
                      className="form-control"
                      placeholder="CEP"
                      value={form.cep}
                      onChange={handleChange}
                      style={{ borderRadius: "6px" }}
                    />
                  </div>
                )}

                <button
                  type="submit"
                  className="btn w-100 fw-bold"
                  style={{
                    backgroundColor: `#${config.secondaryColor || "1e5ba5"}`,
                    color: `#${config.primaryColor || "ffffff"}`,
                    padding: "0.75rem",
                    fontSize: "1rem",
                    borderRadius: "6px",
                    border: `1px solid #${config.primaryColor || "ffffff"}`,
                  }}
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroClassic;
